import { z } from 'zod';
import { idSchema } from './common.js';
export const notificationKindSchema = z.enum([
    'load_assigned',
    'load_status_changed',
    'message_received',
    'hazard_nearby',
    'document_expiring',
    'verification_alert',
    'invoice_sent',
    'invite_received',
    'system',
]);
export const listNotificationsQuerySchema = z.object({
    unreadOnly: z
        .union([z.literal('true'), z.literal('false'), z.boolean()])
        .optional()
        .transform((v) => v === true || v === 'true'),
    limit: z.coerce.number().int().min(1).max(200).default(50),
    /** WD-U4: comma-separated kind filter so the work app can show a
     *  work-only inbox without a second feed. Unknown kinds are a 400, not
     *  silently dropped. */
    kinds: z
        .string()
        .optional()
        .transform((v, ctx) => {
        if (v === undefined || v === '')
            return undefined;
        const out = [];
        for (const part of v.split(',').map((s) => s.trim())) {
            const parsed = notificationKindSchema.safeParse(part);
            if (!parsed.success) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `Unknown notification kind: ${part}`,
                });
                return z.NEVER;
            }
            out.push(parsed.data);
        }
        return out;
    }),
});
export const notificationIdParamSchema = z.object({
    notificationId: idSchema,
});
const channelPrefsSchema = z
    .object({
    push: z.boolean().optional(),
    email: z.boolean().optional(),
    sms: z.boolean().optional(),
    in_app: z.boolean().optional(),
})
    .strict();
/**
 * Sparse map keyed by notification kind. Missing kinds use defaults; missing
 * channels within a kind use defaults. Send only the diff you want to set.
 */
export const notificationPrefsBodySchema = z.record(notificationKindSchema, channelPrefsSchema);
//# sourceMappingURL=notification.js.map